﻿import { Injectable } from '@angular/core';
import { ApiService, UtilService, ApiCacheOptions } from '../../../shared/index';
import { MailChimpSync } from './mailchimp-sync.model';
import { IMailChimpSyncService } from './imailchimp-sync.service';
import { MailChimpServiceApiService } from 'src/app/shared/api/mailchimp-service-api.service';
import { HttpClient, HttpHandler, HttpHeaders } from '@angular/common/http';
import { MailChimpSettingsDto } from 'src/app/admin/global-settings/shared/dto/mail-chimp-settings.dto';
import { MailChimpPingResponseDto } from 'src/app/admin/global-settings/shared/dto/mail-chimp-ping-response.dto';

@Injectable()
export class MailChimpSyncService implements IMailChimpSyncService {
  public constructor(private _mailChimpApiService: MailChimpServiceApiService, private _apiService: ApiService) {}

  GetMailChimpLists(): Promise<any> {
    return this._mailChimpApiService.get('mailchimp/v2/lists');
  }

  FullSync(): void {
    this._mailChimpApiService.post('mailchimp/v2/fullsync', null);
    // this._apiService.post('mailchimp/fullsync', null);
  }

  ManualSync(mailChimpSync: MailChimpSync): void {
    let route: string = 'mailchimp/v2/manualsync';
    this._mailChimpApiService.post(route, mailChimpSync);
  }

  Test(settings: MailChimpSettingsDto): Promise<MailChimpPingResponseDto> {
    return this._mailChimpApiService.post('mailchimp/v2/test', settings);
  }

  FullResetAndSync(): void {
    this._mailChimpApiService.post('mailchimp/v2/FullResetAndSync', null);
  }
}
